import { render, staticRenderFns } from "./addClassify.vue?vue&type=template&id=4db427e4&"
import script from "./addClassify.vue?vue&type=script&lang=js&"
export * from "./addClassify.vue?vue&type=script&lang=js&"
import style0 from "./addClassify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports